
<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card>
            <v-overlay v-model="overlay" 
                    color= "#FE5800" >
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            
            <v-card-title class="pa-0">
                <v-container style="" class="">

                    <v-row align="center" justify="center">

                        <v-col cols="12" sm="12" md="12">
                            
                                        
                            Add Employee
                                        
                                    
                        </v-col>
                                        

                    </v-row>

                </v-container>
            </v-card-title>

            <v-card-text>
                <v-divider></v-divider>
                <v-form v-model="valid" enctype="multipart/form-data" id="createemployee">
                    <v-container>
                        <v-card elevation="3" class="pa-3 mb-3">
                            <v-row>
                                <v-col cols="12" md="12">
                                    <h4 class="title red--text ">Employee Information</h4>
                                </v-col>
                            </v-row>

                            <v-row>
                    
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="name"
                                        name="name"
                                        label="Name"
                                        required
                                        v-validate="'required|max:100'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                    v-model="lastname"
                                    name="lastname"
                                    label="Last Name"
                                    required
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.collect('lastname')"
                                    data-vv-name="lastname"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                    
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="designation"
                                        name="designation"
                                        label="Position"
                                        required
                                        v-validate="'required|max:100'"
                                        :error-messages="errors.collect('designation')"
                                        data-vv-name="designation"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                    v-model="dataofjoining"
                                    name="dataofjoining"
                                    label="Data of Joining"
                                    placeholder="dd/mm/yyyy"
                                    v-mask="mask"
                                    required
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.collect('dataofjoining')"
                                    data-vv-name="dataofjoining"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    
                                    <v-autocomplete 
                                        label="Languages"
                                        v-model="languages"  
                                        name="languages"  
                                        item-text="name"
                                        item-value="value"
                                        multiple
                                        chips
                                        :items="lang" 
                                        :search-input.sync="search"
                                        :items-icons="lang.photo"
                                        @change="search = ''"
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                close
                                                @click="data.select"
                                                @click:close="remove(data.item)"
                                                >
                                                <v-avatar left>
                                                    <v-img :src="data.item.photo"></v-img>
                                                </v-avatar>
                                                {{ data.item.name }}
                                                </v-chip>
                                            </template>

                                            <template v-slot:item="data">
                                                <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                                </template>
                                                <template v-else>
                                                    <v-list-item-avatar>
                                                    <img :src="data.item.photo">
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                    
                                                    </v-list-item-content>
                                                </template>
                                            </template>
            
                                        </v-autocomplete>
                                
                                </v-col>
                            </v-row>    

                            <v-row>
                                <v-col cols="12" md="4" sm="4">
                                    <v-text-field v-model="nationality" name="Where were you born?" label="Where were you born?"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" sm="4">
                                    <v-text-field v-model="hero" name="hero" label="Hero"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" sm="4">
                                    <v-autocomplete 
                                    label="Department "
                                    v-model="department_id"  
                                    name="department_id"  
                                    item-text="departmentName"
                                    item-value="id"  
                                    :items="departments"  
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>    
                            <v-row>
                                <v-col cols="12" md="12">
                                    <h4 class="title">Social Media Urls</h4>
                                </v-col>
                            </v-row>

                            <v-card elevation="3" class="pa-3 mb-3">
                                <v-row v-for="(item, index) in socialmedia" :key="index">
                                    
                                            <v-col cols="12" md="6" >
                                                <!-- <v-autocomplete 
                                                    label="Social Media"
                                                    v-model="item.id"  
                                                    :name="'socialmedia_id['+index+']'"  
                                                    item-text="name"
                                                    item-value="id"  
                                                    :items="socialmedias">
                                                </v-autocomplete> -->
                                                <v-select 
                                                    label="Social Media Icon"
                                                    v-model="item.id"  
                                                    :name="'socialmedia_id['+index+']'"  
                                                    item-text="name"
                                                    item-value="id"
                                                    :items="socialmedias">
                                                    <template v-slot:selection="data">
                                                        <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                    </template>
                                                    <template v-slot:item="data">
                                                        <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="5" sm="5">
                                                <v-text-field
                                                    v-model="item.value"
                                                    :name="'value['+index+']'"
                                                    label="Value"
                                                    >
                                                    
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                <v-row class="">
                                                    <v-col cols="12" md="12" sm="12">
                                                        <a @click="socialmedia.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                    </v-col>
                                                </v-row>
                                        
                                            </v-col>
                                        
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-btn class="add " color="primary" @click="add">Add Social Media</v-btn>
                                    </v-col>
                                </v-row>
                                
                            </v-card>

                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-textarea
                                    v-model="hobbies"
                                    name="hobbies"
                                    label="Tell Us About Your Hobbies & Interests"
                                    ></v-textarea>  
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-label class="font-weight-bold">Description</v-label>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                            
                                    <editor
                                    api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                    initialValue=""
                                    v-model="description"
                                    :init="editorConfig"
                                    ></editor>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <h3 class="title red--text">Select Image</h3>
                                </v-col>
                            </v-row>
                            <v-row>    
                                <v-col cols="12" md="6" sm="6">
                                
                                    <Cropper
                                        classname="cropper"
                                        :src="uploadedimage"
                                        @change="onChange"
                                        :stencilProps="{aspectRatio: 1}"
                                    />
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12" align="center">
                                            <v-btn color="primary" @click="$refs.file.click()"> 
                                                
                                            <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="itemimage"/> Upload Image
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col col="12" md="6" sm="6">
                                    <img style="max-width:100%"  :src="image"    
                                        class="grey lighten-2"  max-height="300"  v-if="image!=null" />
                                </v-col>
                            </v-row> 

                        </v-card>

                        <v-divider></v-divider>
                        <div class="my-3">
                            <v-btn color="primary" @click="submit">Save</v-btn>
                        </div>

                             
                    </v-container>
                </v-form>
            </v-card-text>
                

        </v-card>
    </v-container>
</template>
<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";
    import { Cropper } from 'vue-advanced-cropper'
    import Editor from '@tinymce/tinymce-vue'
    import { mask } from 'vue-the-mask';


    Vue.use(VeeValidate);
    export default
    {
        directives: {
        mask,
        },
        props: 
        {
            source: String
        },
        data: () => 
        ({
            overlay:false,
            hobbies:'',
            socialmedia_id:"",
            socialmedia:[{'id':'','socialmedia':'','value':''}],
            socialmedias:[],
            mask: '##/##/####',
            search:null,
            languages: [],
            lang: [],
            fblink:"",
            instagramlink:"",
            linkedinlink:"",
            twitterlink:"",

            designation:"",
            btnColor:"", 
            valid:true,
            counter: 0,
            name:'',
            lastname:'',
            dataofjoining:'',
            description:'', 
            departments:[],
            department_id:0,
            business_id:"",
        
        
            uploadedimage:null,
            image:null,
            coordinates: {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0
                },
            hero:'',
            nationality:'',    
        }),

        components: 
        {
            Cropper,
            'editor': Editor,
        },
        created() 
        {
            this.storeBusiness=JSON.parse(localStorage.getItem('business'));

            this.business_id=this.storeBusiness.id;

            this.fetchDepartment();
            this.fetchLang();
            this.fetchSocialMedia(); 
        },
        methods: {
            add()
            {
                this.socialmedia.push({
                    'id':'',
                    'socialmedia':'',
                    'value':''
                })
            },
            remove (item) {
                const index = this.languages.indexOf(item.name)
                console.log(item.name+' index '+ this.languages.indexOf(item.name));
                if (index >= 0) this.languages.splice(index, 1)
            },
            onChange({coordinates, canvas}) {
            
                this.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image
                this.image = canvas.toDataURL()
            },
            uploadImage(event) {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                        // create a new FileReader to read this image and convert to base64 format
                        var reader = new FileReader();
                        // Define a callback function to run, when FileReader finishes its job
                        reader.onload = (e) => {
                                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                                // Read image as base64 and set to imageData
                                this.uploadedimage = e.target.result;
                        }
                        // Start the reader job - read file as a data url (base64 format)
                        reader.readAsDataURL(input.files[0]);
                }
            },
            dataURLtoFile(dataurl, filename) 
            {
    
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), 
                    n = bstr.length, 
                    u8arr = new Uint8Array(n);
                    
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
            
                return new File([u8arr], filename, {type:mime});
            },
            fetchSocialMedia()
            {
                this.$http
                .get(this.$apidomain+"socialmedialist")
                .then(res => {
                    this.socialmedias = res.data.socialmedia;
                })
                .catch(err => {
                    console.log(err.response);
                });
            },
            fetchLang()
            {
                    this.$http
                .get(this.$apidomain+"languageslist")
                .then(res => {
                    this.lang = res.data.languages;
                })
                .catch(err => {
                    console.log(err.response);
                });
            },
            fetchDepartment()
            {
                this.$http
                .get(this.$apidomain+"departmentList/"+this.business_id)
                .then(res => {
                    this.departments = res.data.departments;
                    //console.log("types "+ this.types);
                })
                .catch(err => {
                    console.log(err.response);
                });
            },
            submit()
            {
                let th = this;
                if (this.$validator.validateAll()) {
                    let fd = new FormData(document.getElementById("createemployee"));
                    fd.append('socialmedias',JSON.stringify(this.socialmedia));
                    fd.append('businesses_id',this.business_id);
                    fd.append('department_id',this.department_id);
                    fd.append('languages',this.languages);
                    fd.append('description',this.description);
                    if(this.uploadedimage!=null){
                    fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));    
                    }

                    this.overlay=true;

                    this.$http
                    .post(this.$apidomain+"createEmployee", fd)
                    .then(res => {
                        if(res.data.success)  
                        {
                        
                            this.overlay=false;
                            
                            this.$router.push({name:'employeeLists'});

                            // this.$router.push("/agent/employeeList/"+this.business_id);
                        }  
                        else
                        {
                            let errmsg=[];
                            for(var prop in res.data.errors){
                                errmsg.push(res.data.errors[prop][0]);
                            }
                            this.overlay=false;

                            alert(errmsg[0]);
                        }
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            },
        },
    }
</script>
<style >
    .cropper {
	border: solid 1px #EEE;
	height: 300px;
	width: 100%;
}
</style>